import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/close-confirmation/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/close-confirmation/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/detached-triggers-controlled/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/detached-triggers-controlled/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/detached-triggers-simple/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/detached-triggers-simple/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/focus-management/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/focus-management/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/open-from-menu/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/open-from-menu/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/outside-scroll/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/outside-scroll/tailwind/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["ViewSourceLink"] */ "/opt/build/repo/docs/src/components/Subtitle/ViewSourceLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/hero/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/nested/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/inside-scroll/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/uncontained/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.42_@types+react@19.3.0_next@16.3.4_@babel+core@7_a3c696e73efb3246f95ca9ffa03a1f00/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.42_@types+react@19.3.0_next@16.3.4_@babel+core@7_a3c696e73efb3246f95ca9ffa03a1f00/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useCodeFallback"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.42_@types+react@19.3.0_next@16.3.4_@babel+core@7_a3c696e73efb3246f95ca9ffa03a1f00/node_modules/@mui/internal-docs-infra/CodeHighlighter/useCodeFallback.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CoordinatedLazyClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.42_@types+react@19.3.0_next@16.3.4_@babel+core@7_a3c696e73efb3246f95ca9ffa03a1f00/node_modules/@mui/internal-docs-infra/CoordinatedLazy/CoordinatedLazyClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.3.4_@babel+core@7.29.7_supports-color@10.2.2__@playwright+test@1.62.1_@types+no_fc5502943f7231de320c7f4fe0795a0e/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DialogBackdrop"] */ "/opt/build/repo/packages/react/src/dialog/backdrop/DialogBackdrop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogClose"] */ "/opt/build/repo/packages/react/src/dialog/close/DialogClose.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogDescription"] */ "/opt/build/repo/packages/react/src/dialog/description/DialogDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogPopup"] */ "/opt/build/repo/packages/react/src/dialog/popup/DialogPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogPortal"] */ "/opt/build/repo/packages/react/src/dialog/portal/DialogPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogRoot"] */ "/opt/build/repo/packages/react/src/dialog/root/DialogRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogTitle"] */ "/opt/build/repo/packages/react/src/dialog/title/DialogTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogTrigger"] */ "/opt/build/repo/packages/react/src/dialog/trigger/DialogTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogViewport"] */ "/opt/build/repo/packages/react/src/dialog/viewport/DialogViewport.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollAreaContent"] */ "/opt/build/repo/packages/react/src/scroll-area/content/ScrollAreaContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollAreaCorner"] */ "/opt/build/repo/packages/react/src/scroll-area/corner/ScrollAreaCorner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollAreaRoot"] */ "/opt/build/repo/packages/react/src/scroll-area/root/ScrollAreaRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollAreaScrollbar"] */ "/opt/build/repo/packages/react/src/scroll-area/scrollbar/ScrollAreaScrollbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollAreaThumb"] */ "/opt/build/repo/packages/react/src/scroll-area/thumb/ScrollAreaThumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollAreaViewport"] */ "/opt/build/repo/packages/react/src/scroll-area/viewport/ScrollAreaViewport.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/react/src/utils/popups/popupStoreUtils.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/react/src/utils/popups/usePopupHandleStore.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/ReactStore.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/StoreInspector.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/useAnimationFrame.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useRefWithInit"] */ "/opt/build/repo/packages/utils/src/useRefWithInit.ts");
